module.exports = __webpack_public_path__ + "static/media/arabia_beginner.8398b6ee.jpg";